import { render, staticRenderFns } from "./ChecklistV2.vue?vue&type=template&id=15ad9357"
import script from "./ChecklistV2.vue?vue&type=script&lang=js"
export * from "./ChecklistV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports